import { tableConfig } from './tables';

export const locationPath = {
  AGGRID: '/:type',
  DASHBOARD: '/dashboard',
  USER_LIST: '/users',
  ROLE_LIST: '/roles',
  CHANNEL_LIST: '/channels',
  AUDIT_LOGIN_EVENTS: '/loginEvent',
  AUDIT_HTTP_TRACE: '/httptrace',
  COMPONENT_DEMO_PAGE: '/standard',
  ADMINISTRATION: '/administration',
  AUTHORS_WORK: `/${tableConfig.AUTHORS_WORK.name}`,
  MONITORING: `/${tableConfig.MONITORING.name}`,
  PRIVACY_POLICY: '/privacyPolicy',
  PASSWORD_CHANGE_FROM_LINK: '/password-change/:uuid',
  PAGE_NOT_FOUND: '/page-not-found',
  CREATE_USER_FROM_LINK: '/password-create/:uuid',
  CREATE_USER_FROM_LINK_WITHOUT_ID: '/password-create/',
  CODE_CODEBOOK_TYPES: `/${tableConfig.CODE_CODEBOOK_TYPES.name}`,
  COMPILATIONS_VIEW: `/${tableConfig.COMPILATIONS.name}`,
};

export const findPageKey = (currentPath) => {
  let pageKey = '';
  Object.keys(locationPath).forEach(function (key) {
    if (locationPath[key] === currentPath) {
      pageKey = key;
    }
  });
  return pageKey;
};

export const breadcrumbsPageData = (pageKey, menuTranslations) => {
  switch (pageKey) {
    case 'DASHBOARD':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 2,
          name: menuTranslations?.DASHBOARD,
        },
      ];
    case 'USER_LIST':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.USER_LIST,
        },
      ];
    case 'ROLE_LIST':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.ROLE_LIST,
        },
      ];
    case 'CHANNEL_LIST':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.CHANNEL_LIST,
        },
      ];
    case 'AUDIT_LOGIN_EVENTS':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.AUDIT_LOGIN_EVENTS,
        },
      ];
    case 'AUDIT_HTTP_TRACE':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.AUDIT_HTTP_TRACE,
        },
      ];
    case 'COMPONENT_DEMO_PAGE':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.COMPONENT_DEMO_PAGE,
        },
        {
          id: 2,
          name: menuTranslations?.COMPONENT_DEMO_PAGE,
        },
      ];
    case 'ADMINISTRATION':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.ADMINISTRATION,
        },
      ];
    case 'AUTHORS_WORK':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.AUTHORS,
        },
        {
          id: 2,
          name: menuTranslations?.AUTHORS_WORK,
        },
      ];
    case 'MONITORING':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.AUTHORS,
        },
        {
          id: 2,
          name: menuTranslations?.MONITORING,
        },
      ];
    case 'COMPILATIONS_VIEW':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.COMPILATIONS,
        },
        {
          id: 2,
          name: menuTranslations?.COMPILATIONS_VIEW,
        },
      ];
    case 'PRIVACY_POLICY':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 2,
          name: menuTranslations?.PRIVACY_POLICY,
        },
      ];
    case 'CODE_CODEBOOK_TYPES':
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: menuTranslations?.CODE_CODEBOOK_TYPES,
        },
      ];
    default:
      return [
        {
          id: 0,
          name: menuTranslations?.MAIN,
          href: locationPath.DASHBOARD,
        },
        {
          id: 1,
          name: menuTranslations?.ADMINISTRATION_TITLE,
        },
        {
          id: 2,
          name: '',
        },
      ];
  }
};
